import { ComponentClass } from 'react';
export { ComponentClass };
import { LazyModule, LazyImport } from 'owa-bundling';
import { CaptureFeedbackDatapointProps } from './services/captureFeedbackDatapoint';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "FeedbackForm", webpackPrefetch: true */ './lazyIndex')
);

export let CaptureFeedbackDatapoint = new LazyImport(lazyModule, m => m.captureFeedbackDatapoint);

export { CaptureFeedbackDatapointProps };
